module.exports = global["jQuery"] = require("-!C:\\tpi\\code\\v2022dev\\toyota-bz-merge\\node_modules\\expose-loader\\index.js?$!.\\jquery.js");